export enum Tokens {
  REFRESH_TOKEN = 'refreshToken',
  ACCESS_TOKEN = 'accessToken',
  EMAIL = 'email'
}
